import { Box, SxProps, Theme, Typography } from "@mui/material";

export type TypeInfoTextProps = {
  text: string;
  sx?: SxProps<Theme>;
};

export function TypeInfoText({ text, sx }: TypeInfoTextProps) {
  return (
    <Box>
      <Typography sx={{ display: "contents", ...sx }}>{text}</Typography>
    </Box>
  );
}
